/* ============================================================
   SINGSPACE ADMIN - PAGE RÉINITIALISATION MOT DE PASSE
   ============================================================ */

import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Sms, ArrowLeft } from 'iconsax-react';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulation d'un appel API (pour l'instant)
    setTimeout(() => {
      setSuccess(true);
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="split-auth-container">
      {/* Left side - Image */}
      <div className="split-auth-left">
        <div className="split-auth-overlay"></div>
        <div className="split-auth-content">
          <img src="/logo-singspace-blanc.png" alt="SingSpace" className="split-auth-brand" />
          <h1>Réinitialisation</h1>
          <p>
            Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
          </p>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="split-auth-right">
        <div className="split-auth-form-container">
          {/* Logo mobile */}
          <div className="split-auth-logo-mobile">
            <img src="/logo-singspace.png" alt="SingSpace" />
          </div>

          {/* Title */}
          <div className="split-auth-header">
            <h2>Mot de passe oublié ?</h2>
            <p>Nous vous enverrons un lien de réinitialisation</p>
          </div>

          {/* Success message */}
          {success ? (
            <div className="split-alert split-alert-success">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span>Un email de réinitialisation a été envoyé si ce compte existe.</span>
            </div>
          ) : (
            <>
              {/* Form */}
              <form onSubmit={handleSubmit} className="split-auth-form">
                {/* Email */}
                <div className="split-form-group">
                  <label htmlFor="email">Adresse email</label>
                  <div className="split-input-wrapper">
                    <Sms size={20} variant="Bold" className="split-input-icon" />
                    <input
                      type="email"
                      id="email"
                      placeholder="admin@sing.ga"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoFocus
                      className="split-input"
                    />
                  </div>
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  className="split-btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="split-spinner"></span>
                      <span>Envoi en cours...</span>
                    </>
                  ) : (
                    <span>Envoyer le lien</span>
                  )}
                </button>
              </form>
            </>
          )}

          {/* Back to login */}
          <Link to="/login" className="split-link-back">
            <ArrowLeft size={18} />
            <span>Retour à la connexion</span>
          </Link>

          {/* Footer */}
          <div className="split-auth-footer">
            <p>© {new Date().getFullYear()} SING SA - Société d'Incubation Numérique du Gabon</p>
          </div>
        </div>
      </div>
    </div>
  );
}
